import { planningWizardReducer } from 'legacy/lut/components/widgets/public/partner360/planningWizard/features/planningWizard'
import { combineReducers } from 'redux'

import { assortmentSidePanelReducer } from 'partner360/features/assortment'
import { businessPrioritiesReducer } from 'partner360/features/businessPriorities/model/businessPrioritiesSlice'
import { competitorsSobSliceReducer } from 'partner360/features/competitorsSob'
import { contactsReducer } from 'partner360/features/contacts'
import { financialCockpitSliceReducer } from 'partner360/features/financialCockpit/model/financialCockpitSlice'
import { finSobSliceReducer } from 'partner360/features/finSob'
import { finSobSidePanelSliceReducer } from 'partner360/features/finSobSidePanel'
import { generalReportsSlice } from 'partner360/features/generalReports'
import { landingSliceReducer } from 'partner360/features/landing'
import { marketYoyGrowthExpectationReducer } from 'partner360/features/marketYoyGrowthExpectation/model/marketYoyGrowthExpectationSlice'
import { mdfActivitiesReducer } from 'partner360/features/mdfActivities/model/mdfActivitiesSlice'
import { p360PartnerFlagsReducer } from 'partner360/features/p360PartnerFlags'
import { pbmCockpitSliceReducer } from 'partner360/features/pbmCockpit/model/pbmCockpitSlice'
import { QBRSliceReducer } from 'partner360/features/QBR'
import { reportsReducer } from 'partner360/features/reports/model'
import { strategicInitiativesReducer } from 'partner360/features/strategicInitiatives/model/strategicInitiativesSlice'
import { welcomeFlowReducer } from 'partner360/features/welcomeFlow/model/welcomeFlowSlice'

import { basicInfoReducer } from './basicInfo'
import { commitmentReducer } from './commitment'
import { IPartner360State } from './common/models'
import { completenessReducer } from './completeness'
import { composedReportReducer } from './composedReport'
import { configurationReducer } from './configuration'
import { jbpSettingsReducer } from './jbpSettings'
import { marketInfoReducer } from './marketInfo'
import { sectionSettingsReducer } from './sectionSettings'
import { shareOfBusinessReducer } from './shareOfBusiness'

export const partner360Reducer = combineReducers<IPartner360State>({
  welcomeFlow: welcomeFlowReducer,
  businessPriorities: businessPrioritiesReducer,
  mdfActivities: mdfActivitiesReducer,
  marketYoyGrowthExpectation: marketYoyGrowthExpectationReducer,
  strategicInitiatives: strategicInitiativesReducer,
  reports: reportsReducer,
  completeness: completenessReducer,
  basicInfo: basicInfoReducer,
  configuration: configurationReducer,
  sectionSettings: sectionSettingsReducer,
  shareOfBusiness: shareOfBusinessReducer,
  marketInfo: marketInfoReducer,
  jbpSettings: jbpSettingsReducer,
  composedReport: composedReportReducer,
  commitment: commitmentReducer,
  qbr: QBRSliceReducer,
  competitorsSob: competitorsSobSliceReducer,
  assortment: assortmentSidePanelReducer,
  contacts: contactsReducer,
  finSobSidePanel: finSobSidePanelSliceReducer,
  finSob: finSobSliceReducer,
  landing: landingSliceReducer,
  generalReports: generalReportsSlice,
  p360PartnerFlags: p360PartnerFlagsReducer,
  planningWizard: planningWizardReducer,
  financialCockpit: financialCockpitSliceReducer,
  pbmCockpit: pbmCockpitSliceReducer,
})
